import React, { type JSX } from 'react';

import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers-pro';
import moment from 'moment';
import { useAppDispatch, useTypedSelector } from '@fiji/common/src/app/store';
import { setUpdateProperties } from '@fiji/common/src/features/deviceManagement/deviceSlice';
import { FormControl, InputLabel, Select } from '@mui/material';
import useStyles from 'pages/AddDevice/styles';
import { useTheme } from '@mui/styles';
import { CustomTransComponent } from 'components';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';

export const DateUpdateModal = ({ apiData, type }: { apiData?: any; type?: string }): JSX.Element => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const classes = useStyles(theme);
    const { propertiesPayload } = useTypedSelector((state) => state.device);
    const [openSelectBox, setOpenSelectBox] = React.useState(false);
    const handleToggleSelectBox = (): void => {
        setOpenSelectBox(!openSelectBox);
    };

    const getDateCalendarProps = (
        fieldType: 'deviceInstallDate' | 'batteryInstallDate',
        sourceData: any
    ): {
        minDate: moment.Moment;
        maxDate: moment.Moment;
        disableFuture: boolean;
    } => {
        const deviceInstallDate = sourceData?.Device?.find(
            (item: { key: string }) => item?.key === 'deviceInstallDate'
        )?.value;

        const batteryInstallDate = sourceData?.Device?.find(
            (item: { key: string }) => item?.key === 'batteryInstallDate'
        )?.value;

        const baseProps = {
            minDate: moment('2022-01-01'),
            maxDate: moment(),
            disableFuture: true,
        };

        if (fieldType === 'deviceInstallDate' && batteryInstallDate) {
            return {
                ...baseProps,
                maxDate: moment(batteryInstallDate),
            };
        }

        if (fieldType === 'batteryInstallDate' && deviceInstallDate) {
            return {
                ...baseProps,
                minDate: moment(deviceInstallDate),
            };
        }

        return baseProps;
    };

    return (
        <FormControl variant={'filled'} className={classes.formControl} fullWidth>
            <InputLabel id={'select-Assign-to-Group'} required={false}>
                <CustomTransComponent translationKey={'COMMON:DATE'} />
            </InputLabel>
            <Select
                displayEmpty
                id="installdate"
                labelId="demo-customized-select-label"
                renderValue={(): any => (
                    <>
                        {propertiesPayload?.[type as any] ? (
                            moment(propertiesPayload?.[type as any])?.format('LL')
                        ) : (
                            <></>
                        )}
                    </>
                )}
                value={propertiesPayload?.[type as any]}
                open={openSelectBox}
                onClose={handleToggleSelectBox}
                onOpen={handleToggleSelectBox}
            >
                {openSelectBox && (
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DateCalendar
                            {...(type === 'deviceInstallDate' || type === 'batteryInstallDate'
                                ? getDateCalendarProps(type, apiData)
                                : {})}
                            value={propertiesPayload?.[type as any] ? moment(propertiesPayload?.[type as any]) : null}
                            onChange={(date): void =>
                                dispatch(
                                    setUpdateProperties({
                                        key: type,
                                        value: moment(date).endOf('day'),
                                    })
                                )
                            }
                        />
                    </LocalizationProvider>
                )}
            </Select>
        </FormControl>
    );
};
